import React, {useEffect, useState} from 'react'
import {DESIGN_KEY_PREFIX} from "../../constants/design.constant";
import _ from 'lodash'
import ImageShape from "../design-editor/konva-editor/image-shape";

const ShowProductColorTags = ({parent}) => {
    return (
        <>
            <div className="flex flex-wrap">
                {parent?.colors?.map((colorDetail, index) => {
                    return <div key={`color-${index}`}
                                style={{'backgroundColor': `${colorDetail.code}`}}
                                className={`m-1 border border-gray-500 px-2 py-2 rounded flex justify-center 
                                ${colorDetail.code ? 'text-white' : 'bg-gray-200 text-black'} ${colorDetail.name === 'White' ? 'bg-white text-black' : ''}`}>
                    </div>
                })}
            </div>
        </>
    )
}

export default ShowProductColorTags
